const types = {
    FETCH_PRODUCT_SUCCESS: 'FETCH_PRODUCT_SUCCESS',
    FETCH_PRODUCT_FAILED: 'FETCH_PRODUCT_FAILED',
    SHOW_LOADING_PRODUCT: 'SHOW_LOADING_PRODUCT',
    PAGE_PRODUCT: 'PAGE_PRODUCT',
    SORT_PRODUCT: 'SORT_PRODUCT',
    SEARCH_PRODUCT_REQUEST: 'SEARCH_PRODUCT_REQUEST',
    SEARCH_PRODUCT: 'SEARCH_PRODUCT',
    REMOVE_SEARCH_PRODUCT: 'REMOVE_SEARCH_PRODUCT',
    FILTER_PRICE_PRODUCT: 'FILTER_PRICE_PRODUCT',
};

export default types;